// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".styles-module__reassign__29LbF{margin-bottom:24px}.styles-module__reassignRow__2FiWS{flex-wrap:wrap;gap:16px}.styles-module__reassignCol__2B89P{min-width:0;flex:1 1 180px;max-width:280px}.styles-module__reassignTitle__zZniF{color:var(--neutrals-night-40);font-weight:400;size:13px}.styles-module__filter__oMAkp{margin-top:4px;margin-bottom:14px;width:360px}.styles-module__filterUwxUser__cO2mk{margin-top:4px;margin-bottom:14px;width:100%;max-width:250px;min-width:0}.styles-module__marginLeft__1Tett{margin-left:0}", ""]);
// Exports
exports.locals = {
	"reassign": "styles-module__reassign__29LbF",
	"reassignRow": "styles-module__reassignRow__2FiWS",
	"reassignCol": "styles-module__reassignCol__2B89P",
	"reassignTitle": "styles-module__reassignTitle__zZniF",
	"filter": "styles-module__filter__oMAkp",
	"filterUwxUser": "styles-module__filterUwxUser__cO2mk",
	"marginLeft": "styles-module__marginLeft__1Tett"
};
export default exports;
